module.exports = __webpack_public_path__ + "static/media/Tyre.7b1968b0.svg";